import { observer } from "mobx-react-lite"
import { useEffect } from "react"
import { Outlet } from "react-router-dom"
import customerStore from "features/organizations/customers/store/customer-store"
import LowSpinner from "components/common/low-spinner"

const CustomersLoader: React.FC = observer(() => {
    const { customers, loadAllCustomers } = customerStore

    // Load customers if not already loaded
    useEffect(() => {
        if (!customers.length) {
            loadAllCustomers()
        }
    }, [])

    if (!customers.length) {
        return <LowSpinner id={"customer.loading"} />
    } else {
        return <Outlet />
    }
})

export default CustomersLoader
